import { createFileRoute } from "@tanstack/react-router"
import { Chat } from "@/routes/-components/chat"
import { SuspenseWithErrorBoundary } from "@components/suspense"
import { getChatById, getUnreadPageIndex } from "@/orval/gen"
import { Center, Loader, Stack } from "@mantine/core"
import { ChatPage } from "./-components/ChatPage"

const PAGE_SIZE = 25

export interface ChatRouteSearch {
  messageSearch?: string
  searchResult?: number
}

async function getPreloadData(chatId: number, signal: AbortSignal) {
  const unreadState = await getUnreadPageIndex(
    { chatId, pageSize: PAGE_SIZE },
    { signal }
  )
  const chat = await getChatById({ chatId }, { signal })
  return { unreadState, chat }
}

export const Route = createFileRoute("/app/com/chat/$chatId")({
  component: ChatIdPage,
  pendingComponent: PendingChatPage,
  validateSearch: (search: Record<string, unknown>): ChatRouteSearch => ({
    ...(typeof search.messageSearch === "string"
      ? { messageSearch: search.messageSearch }
      : {}),
    ...(typeof search.searchResult === "number" && search.searchResult >= 0
      ? { searchResult: search.searchResult }
      : {}),
  }),
  beforeLoad: (_ctx) => ({
    getTitle: undefined,
  }),
  loader: {
    handler: async ({ params, abortController }) => {
      const chatId = Number(params.chatId)
      return getPreloadData(chatId, abortController.signal)
    },
    staleReloadMode: "blocking",
  },
})

function PendingChatPage() {
  return (
    <Stack h="100%">
      <Center flex="1">
        <Loader />
      </Center>
    </Stack>
  )
}

function ChatIdPage() {
  const loaderData = Route.useLoaderData()

  return (
    <ChatPage>
      <SuspenseWithErrorBoundary>
        <Chat pageSize={PAGE_SIZE} {...loaderData} />
      </SuspenseWithErrorBoundary>
    </ChatPage>
  )
}
